import { useEffect } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import WorksheetSwishHero from './components/WorksheetSwishHero';
import PassosSwish from './components/PassosSwish';
import PraticaSwish from './components/PraticaSwish';
import CompromissoSwish from './components/CompromissoSwish';
import CTAWorksheetSwish from './components/CTAWorksheetSwish';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const worksheetSwishSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'Worksheet Técnica Swish PNL — Guia Completo',
    description: 'Guia completo da Técnica Swish de PNL para reprogramar padrões mentais indesejados e instalar novos comportamentos de alta performance.',
    image: `${SITE_URL}/og-worksheet-swish.png`,
    totalTime: 'PT35M',
    step: [
      {
        '@type': 'HowToStep',
        position: 1,
        name: 'Identifique o Comportamento Indesejado',
        text: 'Escolha um comportamento ou emoção específica que você quer mudar. Seja claro e específico.'
      },
      {
        '@type': 'HowToStep',
        position: 2,
        name: 'Descubra o Gatilho Interno',
        text: 'Identifique a imagem mental que aparece imediatamente antes do comportamento indesejado acontecer.'
      },
      {
        '@type': 'HowToStep',
        position: 3,
        name: 'Crie a Imagem do EU IDEAL',
        text: 'Visualize como você gostaria de reagir na mesma situação. Crie uma imagem poderosa e atraente do seu eu ideal.'
      },
      {
        '@type': 'HowToStep',
        position: 4,
        name: 'Ajuste as Submodalidades',
        text: 'Configure o tamanho, brilho, distância e outras qualidades das duas imagens para máximo impacto.'
      },
      {
        '@type': 'HowToStep',
        position: 5,
        name: 'Execute o Movimento SWISH',
        text: 'Substitua rapidamente a imagem indesejada pela imagem ideal, fazendo o movimento mental de "swish" com velocidade e intensidade.'
      },
      {
        '@type': 'HowToStep',
        position: 6,
        name: 'Repita e Reforce',
        text: 'Repita o processo 10-15 vezes para instalar o novo padrão no subconsciente de forma permanente.'
      }
    ]
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Worksheet Técnica Swish PNL | Guia Completo — Carta do Eu Futuro',
    url: `${SITE_URL}/worksheet-swish`,
    description: 'Worksheet completo da Técnica Swish de PNL. Guia passo a passo para reprogramar padrões mentais indesejados e instalar novos comportamentos de alta performance.',
    inLanguage: 'pt-BR',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Worksheet Swish', item: `${SITE_URL}/worksheet-swish` },
      ],
    },
  }
];

export default function WorksheetSwishPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const autoSave = setInterval(() => {
      const praticaData = localStorage.getItem('pratica-swish');
      if (praticaData) console.log('Auto-save: Dados da prática salvos');
    }, 30000);
    return () => clearInterval(autoSave);
  }, []);

  const handleSalvar = () => {
    const praticaData = localStorage.getItem('pratica-swish');
    const compromissoData = localStorage.getItem('compromisso-swish');
    const dados = {
      pratica: praticaData ? JSON.parse(praticaData) : null,
      compromisso: compromissoData ? JSON.parse(compromissoData) : null,
      dataSalvamento: new Date().toISOString()
    };
    const blob = new Blob([JSON.stringify(dados, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `worksheet-swish-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Worksheet Técnica Swish PNL | Guia Completo — Carta do Eu Futuro"
        description="Worksheet completo da Técnica Swish de PNL. Guia passo a passo para reprogramar padrões mentais indesejados e instalar novos comportamentos de alta performance."
        keywords="worksheet swish, técnica swish, PNL, reprogramação mental, guia prático"
        canonical="/worksheet-swish"
        schema={worksheetSwishSchema}
      />
      <button
        onClick={handleSalvar}
        className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full shadow-2xl hover:scale-110 transition-all duration-300 z-40 flex items-center justify-center whitespace-nowrap"
        title="Salvar Worksheet"
      >
        <i className="ri-save-line text-2xl"></i>
      </button>
      <WorksheetSwishHero />
      <PassosSwish />
      <PraticaSwish />
      <CompromissoSwish />
      <CTAWorksheetSwish />
    </div>
  );
}